import { render } from "./DynamicBadge.vue?vue&type=template&id=384eb87c&ts=true"
import script from "./DynamicBadge.vue?vue&type=script&lang=ts"
export * from "./DynamicBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "384eb87c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('384eb87c', __exports__)) {
    api.reload('384eb87c', __exports__)
  }
  
  module.hot.accept("./DynamicBadge.vue?vue&type=template&id=384eb87c&ts=true", () => {
    api.rerender('384eb87c', render)
  })

}


export default __exports__